export default __webpack_public_path__ + "static/media/asc.dbb0cb9f.svg";